export default __webpack_public_path__ + "static/media/ic-daftar-keluarga.26275a67.svg";